import { Link } from "react-router-dom";
import { blogPosts } from "@/mocks/blogPosts";

export default function BlogPreview() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
            Latest Guides &amp; Resources
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-3 leading-tight">
            ACBuySpreadsheet<br />
            <span className="italic font-normal text-accent-600">Insights &amp; Strategies</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-md">
            Dive into our original guides, comparisons, and tutorials to get the most out of your product sourcing workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-50 cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full aspect-[4/5] overflow-hidden">
                <img
                  src={post.previewImage}
                  alt={post.title}
                  title={post.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] font-medium text-accent-600 uppercase tracking-wider bg-accent-50/70 px-2 py-0.5 rounded-full">
                  {post.category}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-2 line-clamp-2 leading-snug">
                  {post.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-xs text-foreground-400">{post.readTime}</span>
                  <span className="text-xs font-medium text-primary-600 whitespace-nowrap">
                    Read Article &rarr;
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}